import { CategoriaSimulacao } from './../ficha-cadastro-resultado-parcial/model/proposta/categoria-simulacao';
import { RecoverDataProposalOwnVehicle } from './../model/recover-data-proposal/recover-data-proposal-own-vehicle';
import { RecoverDataProposalAddress } from './../model/recover-data-proposal/recover-data-proposal-address';
import { RecoverDataProposalGuarantor } from './../model/recover-data-proposal/recover-data-proposal-guarantor';
import { Referencia } from './../model/referencia';
import { RecoverDataProposalCustomerReference } from './../model/recover-data-proposal/recover-data-proposal-customer-reference';
import { DadosProfissionais } from './../../../shared/dados-profissionais/model/dados-profissionais';
import { RecoverDataProposalProfessionalData } from './../model/recover-data-proposal/recover-data-proposal-professional-data';
import { DadosProfissionaisComponent } from './../../../shared/dados-profissionais/dados-profissionais.component';
import { TipoVeiculoEnum } from './../../../produtos/shared/enums/tipo-veiculo.enum';
import {
  Component,
  DoCheck,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FichaService } from '../../ficha-veiculo.service';
import { setFichaContent } from '../helpers/salvarFicha';
import { FichaCadastro } from './../ficha-cadastro';
import { Data } from '../../../shared/partner/data';
import { EstadoCivilService } from '../../../services/estado-civil/estado-civil.service';
import { finalize, take } from 'rxjs/operators';
import { findDuplicates, onlyDigits } from '../../../shared/helper/utils';
import { Avalista } from '../model/avalista';
import { Telefone } from '../model/telefone';
import { TelefoneCliente } from '../model/telefone-cliente';
import { VeiculoSimulacao } from '../ficha-cadastro-resultado-parcial/model/proposta/veiculo-simulacao';
import { Endereco } from '../model/endereco-cliente';
import { da } from 'date-fns/locale';
import { MarcaSimulacao } from '../ficha-cadastro-resultado-parcial/model/proposta/marca-simulacao';
import { ModeloSimulacao } from '../ficha-cadastro-resultado-parcial/model/proposta/modelo-simulacao';
import { VersaoSimulacao } from '../ficha-cadastro-resultado-parcial/model/proposta/versao-simulacao';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
  NgForm,
} from '@angular/forms';

@Component({
  selector: 'app-ficha-cadastro-detalhe-avalista',
  templateUrl: './ficha-cadastro-detalhe-avalista.component.html',
  styleUrls: ['./ficha-cadastro-detalhe-avalista.component.scss'],
})
export class FichaCadastroDetalheAvalistaComponent
  implements DoCheck, OnDestroy, OnInit
{
  @Input() fichaCadastro: FichaCadastro;
  @Input() index: number;

  @ViewChild('avalistaPpe', { static: true }) avalistaPpe: any;
  @ViewChild('avalistaNaoPpe', { static: true }) avalistaNaoPpe: any;
  @ViewChild('dadosProfissionaisAvalistaComponent', { static: true })
  dadosProfissionaisComponent: DadosProfissionaisComponent;
  @ViewChild('formDetalheAvalista', { static: false })
  formDetalhesAvalista: NgForm;

  private nomeAvalistaOriginal: string;

  nomeAvalista: string;
  emailAvalista: string;
  tipoDocumentoAvalista = 0;
  numeroDocumentoAvalista: string;
  orgaoDocumentoAvalista: string;
  emissaoDocumentoAvalista: string; // Data de emissão
  foneCelularAvalista: string;
  estadoCivilAvalista = 0;
  nomeRealMaeAvalista = '';
  nomeMaeAvalista = '';
  nomePaiAvalista: string;
  nacionalidadeAvalista = 1;
  naturalUfAvalista = '';
  naturalCidadeAvalista = '';
  valorPatrimonioAvalista: number;
  ppeAvalista = false;
  nomeReferenciaAvalista: string;
  foneReferenciaAvalista: string;
  relacReferenciaAvalista = '';
  foneResidencialAvalista: string;
  foneComercialAvalista: string;

  isNomePaiAvalista: boolean = false;

  subsNomeMaeAvalista: Subscription;
  subsNacionalidadeAvalista: Subscription;
  subsNaturalCidadeAvalista: Subscription;
  subsProfissaoAvalista: Subscription;

  listaNomeMaeAvalista = [];
  listaNacionalidadeAvalista = [];
  listaNaturalCidadeAvalista = [];
  listaEstadosCivis = [];

  isLoadingNomeMaeAvalista = false;
  isLoadingNacionalidadeAvalista = false;
  isLoadingNaturalCidadeAvalista = false;
  isLoadingEstadosCivis = false;

  isSelectedTipoDocumentoAvalista = false;
  isSelectedEstadoCivilAvalista = false;
  isSelectedNomeMaeAvalista = false;
  isSelectedBrasilAvalista = true;
  isSelectedNaturalUfAvalista = false;
  isSelectedNaturalCidadeAvalista = false;
  isSelectedProfissaoAvalista = false;
  isSelectedRelacReferenciaAvalista = false;

  minDataEmissao: string;
  maxDataEmissao: string;

  hasData = false;

  isSelectedNaturalCidadeAvalistaAfterBlur = true;

  public nomeReferencia = '';
  public contatoReferencia = '';
  public relacaoReferencia = 0;
  public civilState = '';
  public identification = 0;
  public state = '';
  public city = '';

  public isSemPaiNoRegistro = false;
  public initializePpe = true;

  isNomePaiAvalistaTexto = false;

  dadoProfissional;
  public errorMessage: string;
  private setted = false;
  public errorMessageEmail: string;
  public setteEmail = false;

  constructor(
    private readonly fichaService: FichaService,
    private readonly estadoCivilService: EstadoCivilService
  ) {}

  ngOnInit() {
    if (
      this.fichaCadastro.setDadosAvalistas &&
      this.fichaCadastro.setDadosAvalistas[this.index]
    ) {
      this.fichaCadastro.setDadosAvalistas[this.index] = false;
      if (this.initializePpe) {
        this.initPpe();
      }
      this.assignDataGuarantors();
      this.loadNacionalidadeAvalista();
      this.loadEstadosCivis();
    }
  }

  ngDoCheck() {
    if (!this.hasData && this.fichaCadastro.proposta['avalistas']) {
      this.nomeAvalista = this.nomeAvalistaOriginal;
      this.fichaCadastro.avalistas[this.index].grauParentescoCliente = this
        .fichaCadastro.proposta.avalistas[this.index]
        ? this.fichaCadastro.proposta.avalistas[this.index]
            .grauParentescoCliente
        : undefined;
      this.loadNacionalidadeAvalista();
      this.loadEstadosCivis();
      if (this.initializePpe) {
        this.initPpe();
      }
      this.hasData = true;
    }
  }

  ngOnDestroy() {
    if (this.subsNacionalidadeAvalista) {
      this.subsNacionalidadeAvalista.unsubscribe();
    }
    if (this.subsNaturalCidadeAvalista) {
      this.subsNaturalCidadeAvalista.unsubscribe();
    }
    if (this.subsProfissaoAvalista) {
      this.subsProfissaoAvalista.unsubscribe();
    }
  }

  loadNacionalidadeAvalista() {
    this.listaNacionalidadeAvalista = [];
    this.isLoadingNacionalidadeAvalista = true;
    this.subsNacionalidadeAvalista = this.fichaService
      .getAllNacionalidade()
      .subscribe(
        (res) => {
          this.listaNacionalidadeAvalista = res.nacionalidades;
          this.isLoadingNacionalidadeAvalista = false;
          if (
            this.fichaCadastro.avalistas[this.index].naturalDeUf ||
            this.state
          ) {
            this.loadNaturalCidadeAvalista();
          }
          this.fillNacionalidade(res);
        },
        (err) => {
          this.isLoadingNacionalidadeAvalista = false;
        }
      );
  }

  fillNacionalidade(res) {
    if (!this.fichaCadastro.avalistas[this.index].idNacionalidade) {
      res.nacionalidades.forEach((nacionalidade) => {
        if (nacionalidade.descricao === 'BRASILEIRA') {
          this.fichaCadastro.avalistas[this.index].idNacionalidade =
            nacionalidade.id;
        }
      });
    }
  }

  loadNaturalCidadeAvalista() {
    this.listaNaturalCidadeAvalista = [];
    if (this.fichaCadastro.avalistas[this.index].naturalDeUf || this.state) {
      this.isSelectedNaturalCidadeAvalista = false;
      this.isLoadingNaturalCidadeAvalista = true;
      this.subsNaturalCidadeAvalista = this.fichaService
        .getCidadePorUf(
          this.fichaCadastro.avalistas[this.index].naturalDeUf || this.state
        )
        .subscribe(
          (res) => {
            this.listaNaturalCidadeAvalista = res.cidades;
            this.isLoadingNaturalCidadeAvalista = false;
          },
          (err) => {
            this.isLoadingNaturalCidadeAvalista = false;
          }
        );
    }
  }

  loadEstadosCivis() {
    this.isLoadingEstadosCivis = true;
    this.estadoCivilService
      .getEstadosCivis()
      .pipe(
        take(1),
        finalize(() => (this.isLoadingEstadosCivis = false))
      )
      .subscribe((res) => {
        this.listaEstadosCivis = res;
      });
  }

  onClickNomePaiAvalista() {
    this.isNomePaiAvalista = !this.isNomePaiAvalista;

    if (!this.isNomePaiAvalista) {
      this.fichaCadastro.avalistas[this.index].nomePai = 'NAO DECLARADO';
      this.isSemPaiNoRegistro = true;
    } else {
      this.fichaCadastro.avalistas[this.index].nomePai = '';
      this.isSemPaiNoRegistro = false;
    }
  }

  private setAvalistaNomePaiIfSelected(nomePai: string) {
    if (nomePai === 'NAO DECLARADO') {
      this.fichaCadastro.avalistas[this.index].nomePai = 'NAO DECLARADO';
      this.isSemPaiNoRegistro = true;
      this.isNomePaiAvalista = false;
    } else {
      this.fichaCadastro.avalistas[this.index].nomePai = '';
      this.isSemPaiNoRegistro = false;
      this.isNomePaiAvalista = true;
    }
  }

  onChangeTipoDocumentoAvalista(event) {
    this.isSelectedTipoDocumentoAvalista = event.target.selectedIndex !== 0;
  }

  onChangeNomeMaeAvalista(event) {
    this.nomeRealMaeAvalista = event.target.value;
    this.nomeMaeAvalista =
      this.listaNomeMaeAvalista[event.target.selectedIndex - 1].nomeMae;
    this.isSelectedNomeMaeAvalista = event.target.selectedIndex !== 0;
  }

  onChangeNacionalidadeAvalista(event) {
    this.isSelectedBrasilAvalista = event.target.value === '1';
    this.naturalUfAvalista = '';
    this.naturalCidadeAvalista = '';
    this.isSelectedNaturalUfAvalista = false;
    this.isSelectedNaturalCidadeAvalista = false;
  }

  onChangeNaturalUfAvalista(event) {
    this.naturalUfAvalista = event.target.value;
    this.isSelectedNaturalUfAvalista = true;
    this.naturalCidadeAvalista = '';
    this.isSelectedNaturalCidadeAvalista = false;
    this.loadNaturalCidadeAvalista();
  }

  onChangeNaturalCidadeAvalista(event) {
    this.naturalCidadeAvalista = event.target.value;
    this.isSelectedNaturalCidadeAvalista = event.target.selectedIndex !== 0;
    this.onBlurNaturalCidadeAvalista(event);
  }

  onChangeRelacReferenciaAvalista(event) {
    this.isSelectedRelacReferenciaAvalista = event.target.selectedIndex !== 0;
  }

  onBlurNaturalCidadeAvalista(event) {
    this.isSelectedNaturalCidadeAvalistaAfterBlur =
      event.target.selectedIndex !== 0;
  }

  setAvalistaPpe(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'avalistaPpe') {
      this.avalistaNaoPpe.value = !component.checked;
      this.fichaCadastro.avalistas[this.index].clientePpe = component.checked
        ? 'S'
        : 'N';
      return;
    }

    this.avalistaPpe.value = !component.checked;
    this.fichaCadastro.avalistas[this.index].clientePpe = component.checked
      ? 'N'
      : 'S';
  }

  initPpe() {
    this.fichaCadastro.avalistas[this.index].clientePpe = 'N';
    this.avalistaPpe.value = false;
    this.avalistaNaoPpe.value = true;
    this.initializePpe = false;
  }

  get isEmailInvalido() {
    if (
      this.fichaCadastro._client.email &&
      this.fichaCadastro.avalistas.filter((avalista) => avalista.email).length >
        0
    ) {
      const isEmailEqualCli = this.fichaCadastro.avalistas.some((avalista) => {
        return (
          avalista.email ===
          this.fichaCadastro._client.email.toLocaleLowerCase()
        );
      });

      return (
        isEmailEqualCli ||
        findDuplicates(this.fichaCadastro.avalistas).length > 0 ||
        this.errorMessageEmail !== null
      );
    }
  }

  get numeroAvalista() {
    return Number(this.index) + 1;
  }

  isNextAvailable(form) {
    Object.keys(form.controls).forEach((field) => {
      const control = form.controls[field];
      control.updateValueAndValidity();
    });
    if (
      this.dadosProfissionaisComponent &&
      this.dadosProfissionaisComponent.errorMessage
    ) {
      return false;
    }
    return form.valid && !this.isEmailInvalido && this.errorMessage === null;
  }

  onClickPrevious() {
    this.fichaCadastro.onClickPrevious();
  }

  formatDateMiliseconds(data) {
    return Data.toMilissegundos(data);
  }

  onClickNext() {
    this.setDataAvalista();
    setFichaContent(this.fichaCadastro);
    this.fichaCadastro.onClickNext();
    this.putDataClient();
  }

  private setDataAvalista() {
    if (this.fichaCadastro.avalistas[this.index].avalistaReferencia) {
      this.fichaCadastro.avalistas[this.index].avalistaReferencia =
        {} as Referencia;
    }
    // tslint:disable
    this.fichaCadastro.avalistas[this.index].avalistaReferencia.nome =
      this.nomeReferencia;
    this.fichaCadastro.avalistas[
      this.index
    ].avalistaReferencia.idGrauRelacionamento = this.relacaoReferencia;
    this.fichaCadastro.avalistas[this.index].avalistaReferencia.telefone =
      this.contatoReferencia;
    this.fichaCadastro.avalistas[this.index].idEstadoCivil = this.civilState;
    this.fichaCadastro.avalistas[this.index].idTipoDocumento =
      this.identification;
    this.fichaCadastro.avalistas[this.index].naturalDe = this.city;
    this.fichaCadastro.avalistas[this.index].naturalDeUf = this.state;
    // tslint:enable
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  get isPesados() {
    return this.fichaCadastro.tipoVeiculo === TipoVeiculoEnum.PESADOS;
  }

  private setAvalistaPpeIfSelected(clientePpe: string) {
    if (clientePpe === 'S') {
      this.avalistaPpe.value = true;
      this.avalistaNaoPpe.value = false;
    } else if (clientePpe === 'N') {
      this.avalistaPpe.value = false;
      this.avalistaNaoPpe.value = true;
    }
  }

  private assignDataGuarantors() {
    const avalistas: Avalista = new Avalista();
    const guarantor =
      this.fichaCadastro.recoverData.proposal.guarantors[this.index];

    avalistas.id = guarantor.id;
    avalistas.cpf = guarantor.cpf;
    avalistas.nome = guarantor.name;
    avalistas.renda = guarantor.income;
    avalistas.dataNascimento = this.fichaCadastro.formatDateToString(
      new Date(guarantor.dateOfBirth)
    );
    avalistas.email = guarantor.email;
    avalistas.nomeMae = guarantor.motherName;
    avalistas.nomePai = guarantor.fatherName;
    this.setAvalistaNomePaiIfSelected(avalistas.nomePai);
    avalistas.idTipoDocumento = guarantor.documentTypeId;
    avalistas.rgIe = guarantor.rgIe;
    avalistas.rgIeUf = guarantor.rgIeIssuer;
    avalistas.rgIeData = this.fichaCadastro.formatDateToString(
      guarantor.rgIeDt && guarantor.rgIeDt > 0
        ? new Date(guarantor.rgIeDt)
        : undefined
    );
    avalistas.grauParentescoCliente = String(guarantor.relationship);
    avalistas.tipoEnderecoCorrespondencia = guarantor.mailingAddressType;
    avalistas.rgIeEmissor = guarantor.rgIeIssuer;
    avalistas.idEstadoCivil = guarantor.idCivilStatus;
    avalistas.idNacionalidade = guarantor.nationalityId;
    avalistas.naturalDe = guarantor.naturalness;
    avalistas.naturalDeUf = guarantor.naturalnessFederalUnit;
    avalistas.clientePpe = guarantor.customerPpe;
    this.setAvalistaPpeIfSelected(avalistas.clientePpe);
    avalistas.valorPatrimonio = Number(guarantor.equityValue);
    avalistas.dadoProfissional = this.parseProfessionalData(
      guarantor.professionalData
    );
    avalistas.avalistaReferencia = this.getCustomerReferences(
      guarantor.customerReferences
    );
    avalistas.enderecos = this.parseEndereco(guarantor.addresses, false);
    avalistas.enderecoCorrespondencia = this.parseEndereco(
      guarantor.addresses,
      true
    );
    avalistas.telefones = this.getRecoverDataCustomerPhones(guarantor.phones);

    avalistas.veiculoEmSeuNome = this.parseOwnVehicles(guarantor.ownVehicles);
    avalistas.temProximo = false;

    this.nomeReferencia = guarantor.customerReferences[0]
      ? guarantor.customerReferences[0].name
      : '';
    this.relacaoReferencia = guarantor.customerReferences[0]
      ? guarantor.customerReferences[0].relationshipDegreeId
      : 0;
    if (
      guarantor.customerReferences &&
      guarantor.customerReferences[0] &&
      guarantor.customerReferences[0].phones &&
      guarantor.customerReferences[0].phones[0]
    ) {
      this.contatoReferencia = guarantor.customerReferences[0]
        ? guarantor.customerReferences[0].phones[0].ddd +
          guarantor.customerReferences[0].phones[0].number
        : '';
    } else {
      this.contatoReferencia = '';
    }
    this.civilState = guarantor.idCivilStatus;
    this.identification = guarantor.documentTypeId;
    this.city = guarantor.naturalness;
    this.state = guarantor.naturalnessFederalUnit;

    this.fichaCadastro.avalistas[this.index] = avalistas;
    this.fichaCadastro._avalistas[this.index] = avalistas;
    this.loadNaturalCidadeAvalista();
  }

  parseOwnVehicles(
    ownVehicles: RecoverDataProposalOwnVehicle[]
  ): VeiculoSimulacao {
    const veiculoProprio = new VeiculoSimulacao({});
    if (ownVehicles && ownVehicles.length > 0) {
      veiculoProprio.anoFabricacao = ownVehicles[0].yearManufacture
        ? String(ownVehicles[0].yearManufacture)
        : '';
      veiculoProprio.anoModelo = ownVehicles[0].modelYear
        ? String(ownVehicles[0].modelYear)
        : '';
      veiculoProprio.categoria = new CategoriaSimulacao({
        id: ownVehicles[0].category ? String(ownVehicles[0].category.id) : '0',
        descricao: ownVehicles[0].category
          ? ownVehicles[0].category.description
          : '',
      });
      veiculoProprio.placa = ownVehicles[0].plate ? ownVehicles[0].plate : '';
      veiculoProprio.marca = new MarcaSimulacao({
        id: ownVehicles[0].brand ? String(ownVehicles[0].brand.id) : '0',
        descricao: ownVehicles[0].brand ? ownVehicles[0].brand.description : '',
      });
      veiculoProprio.modelo = new ModeloSimulacao({
        id: ownVehicles[0].model ? String(ownVehicles[0].model.id) : '0',
        descricao: ownVehicles[0].model ? ownVehicles[0].model.description : '',
      });
      veiculoProprio.versao = new VersaoSimulacao({
        id: ownVehicles[0].version ? String(ownVehicles[0].version.id) : '0',
        descricao: ownVehicles[0].version
          ? ownVehicles[0].version.description
          : '',
      });
    }
    return veiculoProprio;
  }

  parseProfessionalData(
    data: RecoverDataProposalProfessionalData
  ): DadosProfissionais {
    if (data) {
      const dadosProfissionais = new DadosProfissionais();
      dadosProfissionais.classeProfissional = {
        id: data.professionalClassId,
        descricao: '',
        empresa: data.companyName ? true : false,
      };
      dadosProfissionais.profissao = {
        idGrupoProfissao: data.professionGroupId,
        id: data.ProfessionId,
        descricao: '',
      };
      dadosProfissionais.empresa = {
        nome: data.companyName,
        telefone: data.phone ? data.phone.ddd + data.phone.number : undefined,
        endereco: {
          idTipoEndereco: data.address ? data.address.addressTypeId : undefined,
          uf: data.address ? data.address.federalUnit : undefined,
          cidade: data.address ? data.address.city : undefined,
          endereco: data.address ? data.address.address : undefined,
          bairro: data.address ? data.address.neighborhood : undefined,
          numero: data.address ? data.address.number : undefined,
          complemento: data.address ? data.address.complement : undefined,
          cep: data.address ? data.address.singleZipCode : undefined,
          condicaoResidencia: data.address
            ? String(data.address.residenceCondition)
            : undefined,
          tempoResidencia:
            data.address && data.address.residenceTime
              ? String(data.address.residenceTime)
              : undefined,
          $cep: data.address ? data.address.singleZipCode : undefined,
          $idTipoEndereco:
            data.address && data.address.addressTypeId
              ? data.address.addressTypeId === 2
                ? data.address.addressTypeId
                : 1
              : undefined,
          condicaoResidenciaOutro: undefined,
        },
        valid: true,
      };
      dadosProfissionais.tempoExperiencia = {
        descricao: '',
        valorNumerico: data.experienceIndustryTime,
      };
      dadosProfissionais.familiaresRamo = data.familyInBusiness;
      this.dadosProfissionaisComponent.setDadosRecuperados(dadosProfissionais);
      return dadosProfissionais;
    }
    return null;
  }

  parseEndereco(
    addresses: RecoverDataProposalAddress[],
    correspondence: boolean
  ) {
    const endereco = new Endereco();

    if (addresses && addresses.length > 0) {
      const address = addresses.find(
        (address) => address.correspondence === correspondence
      );
      if (address) {
        endereco.bairro = address.neighborhood;
        endereco.cep = address.zip || address.singleZipCode;
        endereco.cidade = address.city;
        endereco.complemento = address.complement;
        endereco.condicaoResidencia = String(address.residenceCondition);
        endereco.endereco = address.address;
        endereco.idTipoEndereco = address.addressTypeId;
        endereco.numero = address.number;
        endereco.tempoResidencia = String(address.residenceTime);
        endereco.uf = address.federalUnit;
      }
    }
    return endereco;
  }

  private getCustomerReferences(
    reference: RecoverDataProposalCustomerReference[]
  ): Referencia {
    let data: Referencia = {} as Referencia;
    if (reference && reference.length > 0) {
      reference.forEach((ref: RecoverDataProposalCustomerReference) => {
        if (ref.phones[0]) {
          const telefone = new Telefone(
            ref.phones[0].ddd,
            ref.phones[0].number,
            ref.phones[0].categoryId,
            ref.phones[0].categoryPhoneId
          );
          data = new Referencia(
            ref.name,
            ref.relationshipDegreeId,
            telefone,
            ''
          );
        } else {
          data = new Referencia(ref.name, ref.relationshipDegreeId);
        }
      });
    } else {
      data.nome = '';
      data.idGrauRelacionamento = 0;
      data.relacaoClienteOutro = '0';
    }
    return data;
  }

  private getRecoverDataCustomerPhones(phones: any[]): TelefoneCliente {
    let data: TelefoneCliente = {} as TelefoneCliente;
    if (phones && phones.length > 0) {
      data = new TelefoneCliente(
        phones.map((phone) => ({
          categoria: { id: Number(phone.categoryId) },
          ddd: phone.ddd,
          telefone: phone.number,
        }))
      );
    }
    return data;
  }

  getDddAndCelular(value): { ddd: string; telefone: string } {
    if (!value || value === '') return { ddd: '', telefone: '' };
    const digits = onlyDigits(value);
    const ddd = digits.substring(0, 2);
    const telefone = digits.substring(2);
    return { ddd, telefone };
  }

  validCelphone(): AsyncValidatorFn {
    this.errorMessage = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      if (!control.value || control.value.length === 0) {
        return Promise.resolve(null);
      }
      const dddCelular = this.getDddAndCelular(control.value);
      return this.fichaService
        .verifyCellPhone(dddCelular.ddd, dddCelular.telefone)
        .pipe(take(1))
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessage = null;
            return null;
          }
          this.errorMessage = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }

  clearErrorMessage(erroMessageName: string) {
    this[erroMessageName] = null;
  }

  validEmail(): AsyncValidatorFn {
    this.errorMessageEmail = null;
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      return this.fichaService
        .verifyEmail(control.value)
        .pipe(take(1))
        .toPromise()
        .then((res) => {
          if (res.status !== 'FAIL') {
            this.errorMessageEmail = null;
            return null;
          }
          this.errorMessageEmail = res.messages[0];
          return { genericErrorMessage: res.messages[0] };
        });
    };
  }

  onBlurEmailAvalista(email: string) {
    this.fichaService
      .verifyEmail(email)
      .pipe(take(1))
      .subscribe((res) => {
        if (res.status === 'FAIL') {
          this.errorMessageEmail = res.messages[0];
        } else {
          this.errorMessageEmail = null;
        }
      });
  }

  onBlurTelefoneReferenciaAvalista(phone: string) {
    const dddCelular = this.getDddAndCelular(phone);
    this.fichaService
      .verifyCellPhone(dddCelular.ddd, dddCelular.telefone)
      .pipe(take(1))
      .subscribe((res) => {
        if (res.status === 'FAIL') {
          this.errorMessage = res.messages[0];
        } else {
          this.errorMessage = null;
        }
      });
  }
}
